import type { CmxDocumentContentSlotEntry } from '../noteSlots/CmxDocumentContentViewer';

/**
 * One entry per note carrying a non-blank `cmx_document_content_key` -- `cmx-automate-stub` is the
 * only producer of that shape today (see `cmxDocumentContentSlot.ts`'s `DOCUMENT_ID_PARAM` comment).
 *
 * `renditions` are matched the SAME way legacy notes are matched to their `DocumentMetadata`
 * elsewhere in this adapter (`cases.action.ts`'s `docById.get(n.document_id)`): by numeric
 * `document_id`/`documentId`, not by the cmx-document-content GUID, since nothing on
 * `DocumentMetadata` names the CMX Document Content it was converted from. `cmx-automate-stub` mints
 * `document_id` onto every note indiscriminately (including `CMX_DOCUMENT_CONTENT` ones), so this is
 * exercisable there; against a real backend it stays empty until case-builder's `Note` DTO carries
 * one, which just means no rendition and a hidden original-document button (see `NoteNav`).
 */
export function cmxDocumentContentFromCaseRun(
  run: CMxAPI.CaseRun | undefined,
  documentMetadata: readonly CMxAPI.DocumentMetadata[] = []
): readonly CmxDocumentContentSlotEntry[] {
  const notes = (run?.notes ?? []) as CMxAPI.Note[];
  const sources = notes.filter(
    (note) =>
      typeof note?.cmx_document_content_key === 'string' &&
      note.cmx_document_content_key.trim() !== ''
  );

  return sources.map((source) => ({
    documentId: source.cmx_document_content_key as string,
    renditions: documentMetadata.filter(
      (doc) => doc.documentId === source.document_id
    )
  }));
}
